import { render, staticRenderFns } from "./User_profile.vue?vue&type=template&id=4c7e9461&"
import script from "./User_profile.vue?vue&type=script&lang=js&"
export * from "./User_profile.vue?vue&type=script&lang=js&"
import style0 from "./User_profile.vue?vue&type=style&index=0&id=4c7e9461&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports